import { StatePropertyRef } from '../../canvas/ExtendableStore';

export interface CallMember {
    id: string;
    videoTrack: any;
    audioTrack: any;
}

export type ActiveCallStateKey = 'none' | 'connecting' | 'active';
export interface ActiveCallInfo {
    key: ActiveCallStateKey;
    members?: Record<string, CallMember>;
}

export const CreateActiveCallInfo = (key: ActiveCallStateKey) => ({ key }) as ActiveCallInfo;

export const ActiveCallInfo = StatePropertyRef<ActiveCallInfo>('activeCall', CreateActiveCallInfo('none'));
